export default "__VITE_ASSET__$yH8SdV3__"